import { Button } from '@mui/material';
import { colors } from '@src/styles';
import { monoFontFamily } from '../../scriptsStyles';

interface TabButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const TabButton = ({ label, isActive, onClick }: TabButtonProps) => {
  return (
    <Button
      role="tab"
      aria-selected={isActive}
      onClick={onClick}
      sx={{
        minWidth: 0,
        height: 26,
        px: 1.5,
        borderRadius: '6px',
        fontFamily: monoFontFamily,
        fontSize: '11.5px',
        textTransform: 'none',
        color: isActive ? colors.primary.yellow : colors.brand.textSecondary,
        bgcolor: isActive ? 'rgba(255, 160, 21, 0.14)' : 'transparent',
        '&:hover': {
          bgcolor: isActive ? 'rgba(255, 160, 21, 0.2)' : 'rgba(255, 255, 255, 0.05)',
          color: isActive ? colors.primary.yellow : colors.primary.white,
        },
      }}
    >
      {label}
    </Button>
  );
};
